// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadPanel/index.css
// module id = 2298
// module chunks = 0